import approvedProcessingDraftReducer from "./approvedProcessingDraftReducer";

const approvedProcessingDraftReducers = {
    approvedProcessingDraft: approvedProcessingDraftReducer,
}

export default approvedProcessingDraftReducers;